import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Navigation, { DRAWER_WIDTH } from './Navigation';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Navigation />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        {/* This Toolbar acts as a spacer for the fixed AppBar */}
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}
